/**
 * The landing page for PAYMENT REDUCTION leads.
 *
 * Copy approved in "MCC Landing Page Copy - Transition Changes By Phases", Personalised
 * PURL LP 1. Same page as `RateReduction` with a different headline: these members were
 * mailed about the monthly payment, not the rate, so that is the number they see.
 *
 * Reached by `?t=paymentReduction`, or by `Offer.landingPage` on the offers in a
 * payment-reduction drop. See `-/util/landingPages`.
 */
import {formatMoney} from 'accounting';
import classNames from 'classnames';
import {Fragment} from 'react';
import injectSheet from 'react-jss';

import reductionStyles from '-/styles/sections/reductionLanding';
import {
    ADVERTISED_PAYMENT_REDUCTION,
    CallToAction,
    greetingFor,
    LifetimeSavings,
    paymentWouldRise,
    Reward,
    Rule,
    ThisIsNotMe
} from '-/components/landing/reduction';

const PaymentReductionLanding = props => {
    const {
        applicantName,
        classes = {},
        currentStepLastSession,
        dealInfo = {}
    } = props;

    const {giftAmount, lifeTimeSavings} = dealInfo;
    // The figure is the advertised ceiling, so the only question is whether this
    // member may be shown the claim at all.
    const showOffer = !paymentWouldRise(dealInfo);

    return (
        <section className={classes.root}>
            <h1>
                {greetingFor(applicantName, {
                    hasGoodNews: showOffer,
                    returning: Boolean(currentStepLastSession)
                })}
            </h1>
            {showOffer && (
                <Fragment>
                    <p className={classes.p}>
                        You could lower your monthly payment by up to
                    </p>
                    {/*
                      * "$109/MONTH" is one baseline with three sizes, so it is one
                      * element with spans rather than three stacked lines.
                      */}
                    <p className={classes.amount}>
                        <span className={classes.amountSymbol}>$</span>
                        {formatMoney(ADVERTISED_PAYMENT_REDUCTION, {precision: 0, symbol: ''})}
                        <span className={classes.amountPeriod}>/MONTH*</span>
                    </p>
                </Fragment>
            )}
            <p className={classNames(classes.p, classes.beforeCta)}>
                Take the next step toward a lower payment and more savings.
            </p>
            <CallToAction {...props} classes={classes} />
            <Rule classes={classes} />
            <Reward classes={classes} giftAmount={giftAmount} />
            <ThisIsNotMe classes={classes} />
            <Rule classes={classes} />
            <LifetimeSavings classes={classes} lifeTimeSavings={lifeTimeSavings} />
        </section>
    );
};

export default injectSheet(reductionStyles)(PaymentReductionLanding);
